"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CardRow_1 = __importDefault(require("./CardRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MortgageCardForm = function (_a) {
    var formikProps = _a.formikProps, order = _a.order, name = _a.name, post = _a.post, validatedMediaDescriptionRows = _a.validatedMediaDescriptionRows, index = _a.index, mortgageId = _a.mortgageId, addRemovedMortgageId = _a.addRemovedMortgageId;
    return (react_1.default.createElement("div", { className: classnames_1.default('ui grid stackable form', styles_module_scss_1.default.building_card_form) },
        react_1.default.createElement(CardRow_1.default, { rows: validatedMediaDescriptionRows, order: order, name: name, formikProps: formikProps, post: post, index: index, mortgageId: mortgageId, addRemovedMortgageId: addRemovedMortgageId })));
};
exports.default = MortgageCardForm;
